// frontend/src/components/OfflineNotification.jsx
import { useEffect, useState } from 'react';

export default function OfflineNotification() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Mostrar mensagem de reconexão brevemente
      if (wasOffline) {
        setTimeout(() => setWasOffline(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Service Worker registration is now handled by vite-plugin-pwa

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !wasOffline) return null;

  return (
    <div
      className={`fixed-bottom alert alert-dismissible fade show mb-0 rounded-0 ${isOnline ? 'alert-success' : 'alert-warning'
        }`}
      style={{ zIndex: 9999 }}
    >
      <div className="d-flex align-items-center">
        <i className={`bi ${isOnline ? 'bi-wifi' : 'bi-wifi-off'} me-2`}></i>
        <span>
          {isOnline
            ? 'Conexão restaurada! Dados atualizados.'
            : 'Modo offline ativo - Dados podem não estar atualizados'}
        </span>
        {isOnline && (
          <button
            type="button"
            className="btn-close ms-auto"
            onClick={() => setWasOffline(false)}
            aria-label="Fechar"
          />
        )}
      </div>
    </div>
  );
}

